import { ArsTableCellData } from "../interface";
import { isArsTableBodyCell } from "./isArsTableBodyCell";
import { isArsTableHeaderCell } from "./isArsTableHeaderCell";

/**
 * Type guard for ArsTableCellData, which can be either an ArsTableHeaderCell or an ArsTableBodyCell.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableCellData, false otherwise
 */
export const isArsTableCellData = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableCellData<T> => isArsTableHeaderCell(obj, isT) || isArsTableBodyCell(obj, isT);
